// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const CLOSE_POP_UP_GOOGLE = 'CLOSE_POP_UP_GOOGLE';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';

//Quota
export const FETCH_QUOTA = 'FETCH_QUOTA';
export const FETCH_QUOTA_SUCCESS = 'FETCH_QUOTA_SUCCESS';
export const FETCH_QUOTA_ERROR = 'FETCH_QUOTA_ERROR';
export const LOAD_MORE_QUOTA = 'LOAD_MORE_QUOTA';
export const LOAD_MORE_QUOTA_SUCCESS = 'LOAD_MORE_QUOTA_SUCCESS';
export const LOAD_MORE_QUOTA_ERROR = 'LOAD_MORE_QUOTA_ERROR';
export const ADD_QUOTA = 'ADD_QUOTA';
export const ADD_QUOTA_SUCCESS = 'ADD_QUOTA_SUCCESS';
export const ADD_QUOTA_ERROR = 'ADD_QUOTA_ERROR';
export const RESET_ADD_QUOTA = 'RESET_ADD_QUOTA';

//Crisis
export const FETCH_CRISIS = 'FETCH_CRISIS';
export const FETCH_CRISIS_SUCCESS = 'FETCH_CRISIS_SUCCESS';
export const FETCH_CRISIS_ERROR = 'FETCH_CRISIS_ERROR';
export const LOAD_MORE_CRISIS = 'LOAD_MORE_CRISIS';
export const LOAD_MORE_CRISIS_SUCCESS = 'LOAD_MORE_CRISIS_SUCCESS';
export const LOAD_MORE_CRISIS_ERROR = 'LOAD_MORE_CRISIS_ERROR';
export const ADD_CRISIS = 'ADD_CRISIS';
export const ADD_CRISIS_SUCCESS = 'ADD_CRISIS_SUCCESS';
export const ADD_CRISIS_ERROR = 'ADD_CRISIS_ERROR';
export const RESET_ADD_CRISIS = 'RESET_ADD_CRISIS';

//Buzz
export const FETCH_BUZZ = 'FETCH_BUZZ';
export const FETCH_BUZZ_SUCCESS = 'FETCH_BUZZ_SUCCESS';
export const FETCH_BUZZ_ERROR = 'FETCH_BUZZ_ERROR';
export const ADD_BUZZ = 'ADD_BUZZ';
export const ADD_BUZZ_SUCCESS = 'ADD_BUZZ_SUCCESS';
export const ADD_BUZZ_ERROR = 'ADD_BUZZ_ERROR';
export const UPDATE_BUZZ = 'UPDATE_BUZZ';
export const UPDATE_BUZZ_SUCCESS = 'UPDATE_BUZZ_SUCCESS';
export const UPDATE_BUZZ_ERROR = 'UPDATE_BUZZ_ERROR';
export const DELETE_BUZZ = 'DELETE_BUZZ';
export const DELETE_BUZZ_SUCCESS = 'DELETE_BUZZ_SUCCESS';
export const DELETE_BUZZ_ERROR = 'DELETE_BUZZ_ERROR';
export const RESET_ADD_BUZZ = 'RESET_ADD_BUZZ';

//Campaign
export const FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
export const FETCH_CAMPAIGN_ERROR = 'FETCH_CAMPAIGN_ERROR';
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const ADD_CAMPAIGN_SUCCESS = 'ADD_CAMPAIGN_SUCCESS';
export const ADD_CAMPAIGN_ERROR = 'ADD_CAMPAIGN_ERROR';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_ERROR = 'UPDATE_CAMPAIGN_ERROR';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const DELETE_CAMPAIGN_ERROR = 'DELETE_CAMPAIGN_ERROR';
export const RESET_ADD_CAMPAIGN = 'RESET_ADD_CAMPAIGN';

//RateCard
export const FETCH_RATE_CARD = 'FETCH_RATE_CARD';
export const FETCH_RATE_CARD_SUCCESS = 'FETCH_RATE_CARD_SUCCESS';
export const FETCH_RATE_CARD_ERROR = 'FETCH_RATE_CARD_ERROR';
export const UPDATE_RATE_CARD = 'UPDATE_RATE_CARD';
export const UPDATE_RATE_CARD_SUCCESS = 'UPDATE_RATE_CARD_SUCCESS';
export const UPDATE_RATE_CARD_ERROR = 'UPDATE_RATE_CARD_ERROR';
export const RESET_UPDATE_RATE_CARD = 'RESET_UPDATE_RATE_CARD';

//RateCardValue
export const FETCH_RATE_CARD_VALUE = 'FETCH_RATE_CARD_VALUE';
export const FETCH_RATE_CARD_VALUE_SUCCESS = 'FETCH_RATE_CARD_VALUE_SUCCESS';
export const FETCH_RATE_CARD_VALUE_ERROR = 'FETCH_RATE_CARD_VALUE_ERROR';
export const UPDATE_RATE_CARD_VALUE = 'UPDATE_RATE_CARD_VALUE';
export const UPDATE_RATE_CARD_VALUE_SUCCESS = 'UPDATE_RATE_CARD_VALUE_SUCCESS';
export const UPDATE_RATE_CARD_VALUE_ERROR = 'UPDATE_RATE_CARD_VALUE_ERROR';
export const RESET_UPDATE_RATE_CARD_VALUE = 'RESET_UPDATE_RATE_CARD_VALUE';

//PeopleLevelInBrand
export const FETCH_PEOPLE_LEVEL_IN_BRAND = 'FETCH_PEOPLE_LEVEL_IN_BRAND';
export const FETCH_PEOPLE_LEVEL_IN_BRAND_SUCCESS = 'FETCH_PEOPLE_LEVEL_IN_BRAND_SUCCESS';
export const FETCH_PEOPLE_LEVEL_IN_BRAND_ERROR = 'FETCH_PEOPLE_LEVEL_IN_BRAND_ERROR';
export const UPDATE_PEOPLE_LEVEL_IN_BRAND = 'UPDATE_PEOPLE_LEVEL_IN_BRAND';
export const UPDATE_PEOPLE_LEVEL_IN_BRAND_SUCCESS = 'UPDATE_PEOPLE_LEVEL_IN_BRAND_SUCCESS';
export const UPDATE_PEOPLE_LEVEL_IN_BRAND_ERROR = 'UPDATE_PEOPLE_LEVEL_IN_BRAND_ERROR';
export const RESET_UPDATE_PEOPLE_LEVEL_IN_BRAND = 'RESET_UPDATE_PEOPLE_LEVEL_IN_BRAND';

//PeopleLevelInCampaign
export const FETCH_PEOPLE_LEVEL_IN_CAMPAIGN = 'FETCH_PEOPLE_LEVEL_IN_CAMPAIGN';
export const FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS = 'FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS';
export const FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR = 'FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR';
export const UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN = 'UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN';
export const UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS = 'UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS';
export const UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR = 'UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR';
export const RESET_UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN = 'RESET_UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN';

//Freq
export const FETCH_FREQ = 'FETCH_FREQ';
export const FETCH_FREQ_SUCCESS = 'FETCH_FREQ_SUCCESS';
export const FETCH_FREQ_ERROR = 'FETCH_FREQ_ERROR';
export const UPDATE_FREQ = 'UPDATE_FREQ';
export const UPDATE_FREQ_SUCCESS = 'UPDATE_FREQ_SUCCESS';
export const UPDATE_FREQ_ERROR = 'UPDATE_FREQ_ERROR';
export const RESET_UPDATE_FREQ = 'RESET_UPDATE_FREQ';

//Category
export const FETCH_CATEGORY = 'FETCH_CATEGORY';
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
export const FETCH_CATEGORY_ERROR = 'FETCH_CATEGORY_ERROR';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_ERROR = 'ADD_CATEGORY_ERROR';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_ERROR = 'UPDATE_CATEGORY_ERROR';
export const RESET_UPDATE_CATEGORY = 'RESET_UPDATE_CATEGORY';

//Industry
export const FETCH_INDUSTRY = 'FETCH_INDUSTRY';
export const FETCH_INDUSTRY_SUCCESS = 'FETCH_INDUSTRY_SUCCESS';
export const FETCH_INDUSTRY_ERROR = 'FETCH_INDUSTRY_ERROR';
export const ADD_INDUSTRY = 'ADD_INDUSTRY';
export const ADD_INDUSTRY_SUCCESS = 'ADD_INDUSTRY_SUCCESS';
export const ADD_INDUSTRY_ERROR = 'ADD_INDUSTRY_ERROR';
export const UPDATE_INDUSTRY = 'UPDATE_INDUSTRY';
export const UPDATE_INDUSTRY_SUCCESS = 'UPDATE_INDUSTRY_SUCCESS';
export const UPDATE_INDUSTRY_ERROR = 'UPDATE_INDUSTRY_ERROR';
export const RESET_UPDATE_INDUSTRY = 'RESET_UPDATE_INDUSTRY';

//Role
export const FETCH_ROLE = 'FETCH_ROLE';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_ERROR = 'FETCH_ROLE_ERROR';
export const ADD_ROLE = 'ADD_ROLE';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_ERROR = 'ADD_ROLE_ERROR';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_ERROR = 'UPDATE_ROLE_ERROR';
export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_ERROR = 'DELETE_ROLE_ERROR';
export const RESET_ADD_ROLE = 'RESET_ADD_ROLE';

//Sample size
export const FETCH_SAMPLE_SIZE = 'FETCH_SAMPLE_SIZE';
export const FETCH_SAMPLE_SIZE_SUCCESS = 'FETCH_SAMPLE_SIZE_SUCCESS';
export const FETCH_SAMPLE_SIZE_ERROR = 'FETCH_SAMPLE_SIZE_ERROR';
export const RESET_SAMPLE_SIZE = 'RESET_SAMPLE_SIZE';
export const UPDATE_SAMPLE_SIZE = 'UPDATE_SAMPLE_SIZE';

//Multi Sample size
export const FETCH_MULTI_SAMPLE_SIZE = 'FETCH_MULTI_SAMPLE_SIZE';
export const FETCH_MULTI_SAMPLE_SIZE_SUCCESS = 'FETCH_MULTI_SAMPLE_SIZE_SUCCESS';
export const FETCH_MULTI_SAMPLE_SIZE_ERROR = 'FETCH_MULTI_SAMPLE_SIZE_ERROR';
export const RESET_MULTI_SAMPLE_SIZE = 'RESET_MULTI_SAMPLE_SIZE';

//Analysis level guide
export const FETCH_ANALYSIS_LEVEL_GUIDE = 'FETCH_ANALYSIS_LEVEL_GUIDE';
export const FETCH_ANALYSIS_LEVEL_GUIDE_SUCCESS = 'FETCH_ANALYSIS_LEVEL_GUIDE_SUCCESS';
export const FETCH_ANALYSIS_LEVEL_GUIDE_ERROR = 'FETCH_ANALYSIS_LEVEL_GUIDE_ERROR';
export const RESET_ANALYSIS_LEVEL_GUIDE = 'RESET_ANALYSIS_LEVEL_GUIDE';

//Log
export const FETCH_LOG = 'FETCH_LOG';
export const FETCH_LOG_SUCCESS = 'FETCH_LOG_SUCCESS';
export const FETCH_LOG_ERROR = 'FETCH_LOG_ERROR';
export const ADD_LOG = 'ADD_LOG';
export const ADD_LOG_SUCCESS = 'ADD_LOG_SUCCESS';
export const ADD_LOG_ERROR = 'ADD_LOG_ERROR';

//Reset Store
export const RESET_STORE = 'RESET_STORE';
